import React from 'react';

/**
 * Button — variants: primary | secondary | ghost | destructive.
 * `size="sm"` for toolbar density; `pill` for filter buttons.
 * When `loading`, shows an in-place label and is disabled (per spec).
 */
export default function Button({
  variant = 'secondary',
  size,
  pill = false,
  loading = false,
  loadingLabel = 'Procesando…',
  disabled = false,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'ui-btn',
    `ui-btn--${variant}`,
    size === 'sm' ? 'ui-btn--sm' : '',
    pill ? 'ui-btn--pill' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {loading ? loadingLabel : children}
    </button>
  );
}
